module.exports = __webpack_public_path__ + "static/CactusHead-171bd00df5c94b932b7f5abec568a285.png";